import React, {useEffect, useMemo} from 'react';
import ReportUtils from "../../../../../../utils/report-utils.js";
import {generateDispatchList} from "./generate-sheets.js";


const DispatchCards = ({data, boName, dispatchList}) => {
  const summaryLabels = useMemo(() => [
    "Total de despachos",
    "Total de atendimentos",
    "Desvios de natureza",
    "Flagrantes",
    "Atos infracionais",
    "Patrimônio público",
    boName,
    "BO terceiro",
    "Não constatado",
  ], [])

  useEffect(() => {
    generateDispatchList(dispatchList);
    const summaryValues = [
      data.dispatch_total ?? 0,
      data.attendance_total ?? 0,
      data.nature_deviation ?? 0,
      data.flagrant_total ?? 0,
      data.infracional_total ?? 0,
      data.public_assets_total ?? 0,
      data.bos_total ?? 0,
      data.thyrd_bos_total ?? 0,
      data.not_found_total ?? 0,
    ];

    ReportUtils.createExportableTable(summaryLabels, summaryValues, "Cards");
  }, [data]);

  return (
    <>
      <div className="grid grid-cols-3 gap-2">
        <div className="mb-1">
          <div className="text-center">
            <div className="box boxCount cursor-pointer">
              <h3>{summaryLabels[0]}</h3><h2>{data.dispatch_total ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1">
          <div className="text-center">
            <div className="box boxCount cursor-pointer">
              <h3>{summaryLabels[1]}</h3><h2>{data.attendance_total ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1">
          <div className="text-center">
            <div className="box boxCount cursor-pointer">
              <h3>{summaryLabels[2]}</h3><h2>{data.nature_deviation ?? 0}</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 justify-content-center align-items-center">
        <div className="mb-1 mt-1">
          <div className="text-center">
            <div className="box boxCount cursor-pointer">
              <h3>{summaryLabels[3]}</h3><h2>{data.flagrant_total ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-1">
          <div className="text-center">
            <div className="box boxCount cursor-pointer">
              <h3>{summaryLabels[4]}</h3><h2>{data.infracional_total ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-1">
          <div className="text-center">
            <div className="box boxCount cursor-pointer">
              <h3>{summaryLabels[5]}</h3><h2>{data.public_assets_total ?? 0}</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 justify-content-center align-items-center">
        <div className="mb-1 mt-1">
          <div className="text-center">
            <div className="box boxCount cursor-pointer">
              <h3>{summaryLabels[6]}</h3><h2>{data.bos_total ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-1">
          <div className="text-center">
            <div className="box boxCount cursor-pointer">
              <h3>{summaryLabels[7]}</h3><h2>{data.thyrd_bos_total ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-1">
          <div className="text-center">
            <div className="box boxCount cursor-pointer">
              <h3>{summaryLabels[8]}</h3><h2>{data.not_found_total ?? 0}</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default DispatchCards;